import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DateTimeDisplay from '../DateTimeDisplay';
import LoginHistoryTable from './LoginHistoryTable';

const apiUrl = window._env_?.REACT_APP_API_URL || 'https://app.mylocaleventrentals.com/api';

const UserTab = () => {
  const [profile, setProfile] = useState(null);
  const [loginHistory, setLoginHistory] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setLoaded(true);
      return;
    }
    const load = async () => {
      try {
        const res = await axios.get(`${apiUrl}/user/profile`, {
          headers: { 'x-auth-token': token },
        });
        setProfile(res.data?.user || null);
        setLoginHistory(res.data?.loginHistory || []);
      } catch {
        setError('Failed to load your account profile.');
      } finally {
        setLoaded(true);
      }
    };
    load();
  }, []);

  return (
    <div className="space-y-8">
      <section className="rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden">
        <div className="border-b border-gray-100 bg-gray-50 px-5 py-3">
          <h2 className="text-lg font-semibold text-gray-900">Your account</h2>
          <p className="text-sm text-gray-600 mt-0.5">Currently signed-in user.</p>
        </div>
        <div className="p-5">
          {!loaded ? (
            <p className="text-sm text-gray-500">Loading…</p>
          ) : error ? (
            <p className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</p>
          ) : profile ? (
            <dl className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 text-sm">
              <div>
                <dt className="text-gray-500">Username</dt>
                <dd className="mt-0.5 font-medium text-gray-900">{profile.username || '—'}</dd>
              </div>
              <div>
                <dt className="text-gray-500">Email</dt>
                <dd className="mt-0.5 font-medium text-gray-900">{profile.email || '—'}</dd>
              </div>
              <div>
                <dt className="text-gray-500">Role</dt>
                <dd className="mt-0.5">
                  <span
                    className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold ${
                      String(profile.role || '').toLowerCase() === 'admin'
                        ? 'bg-purple-100 text-purple-800'
                        : 'bg-gray-200 text-gray-700'
                    }`}
                  >
                    {profile.role || '—'}
                  </span>
                </dd>
              </div>
              <div>
                <dt className="text-gray-500">Last login</dt>
                <dd className="mt-0.5 font-medium text-gray-900">
                  {profile.lastLogin ? (
                    <DateTimeDisplay value={profile.lastLogin} />
                  ) : (
                    '—'
                  )}
                </dd>
              </div>
            </dl>
          ) : (
            <p className="text-sm text-gray-500">No profile information available.</p>
          )}
        </div>
      </section>

      <section className="rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden">
        <div className="border-b border-gray-100 bg-gray-50 px-5 py-3">
          <h2 className="text-lg font-semibold text-gray-900">Login history</h2>
          <p className="text-sm text-gray-600 mt-0.5">
            Recent sign-ins for your account (last 10). IP location is approximate.
          </p>
        </div>
        <div className="p-5">
          {!loaded ? (
            <p className="text-sm text-gray-500">Loading…</p>
          ) : error ? null : (
            <LoginHistoryTable rows={loginHistory} />
          )}
        </div>
      </section>

      <section className="rounded-xl border border-dashed border-gray-300 bg-gray-50/80 px-5 py-6">
        <h2 className="text-lg font-semibold text-gray-800">User management</h2>
        <p className="text-sm text-gray-600 mt-1">
          Inviting and managing staff users (roles, deactivation, password resets) is coming soon. For now, contact an
          administrator to make changes.
        </p>
      </section>
    </div>
  );
};

export default UserTab;
